import React, { useEffect, useState } from "react";
import MarkdownRenderer from "./MarkdownRenderer";

const PostRenderer = ({ slug, folderName }) => {
  const [post, setPost] = useState(null);

  useEffect(() => {
    fetch(`/content/${folderName}/json/${slug}.json`)
      .then((res) => {
        if (!res.ok) throw new Error("Post not found");
        return res.json();
      })
      .then(setPost)
      .catch((error) => {
        console.error(error);
        setPost(null);
      });
  }, [slug, folderName]);

  if (!post) return <p>Loading post...</p>;

  return <MarkdownRenderer post={post} />;
};

export default PostRenderer;
